import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {

}

@Component({
  selector: 'app-edit-awb-number',
  templateUrl: './edit-awb-number.component.html',
  styleUrls: ['./edit-awb-number.component.scss']
})
export class EditAwbNumberComponent implements OnInit {

  awbNumber;
  shipmentData;
  orderId;

  constructor(
    private toastr: ToastrService,
    private adminService: AdminService,
    public dialogref: MatDialogRef<EditAwbNumberComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
    this.shipmentData = this.data["data"];
    this.orderId = this.data["order_id"];
    this.awbNumber = this.shipmentData.vendor_shipments[0].courier_tracking_number;

  }

  close() {
    this.dialogref.close();
  }

  update() {
    let shipment_id = this.shipmentData.vendor_shipments[0].id;
    let form = {
      "vendor_shipment": {
        "courier_tracking_number": this.awbNumber
      }
    }

    this.adminService.editAwbNumber(this.orderId, shipment_id, form).subscribe(
      res => {        
        this.toastr.success('AWB Tracking No is updated', 'Success');
        this.close();
      },
      err => {
        this.toastr.error('Something went wrong', 'Error');
        this.close();
      }
    )

  }

}
